import { render, staticRenderFns } from "./parentList.vue?vue&type=template&id=fda1f5a2&"
import script from "./parentList.vue?vue&type=script&lang=js&"
export * from "./parentList.vue?vue&type=script&lang=js&"
import style0 from "./parentList.vue?vue&type=style&index=0&id=fda1f5a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports